import { LitElement } from "lit";
import { customElement } from "lit/decorators.js";
import { SlhFormElement } from "@slhui/base/form";
import { SlhFormIcons } from "@slhui/form-icons";
import { SlhCoreTextarea } from "@slhuicore/textarea";

import { style } from "./assets/textarea.generated-style";

/**
 * Allow users to add textarea field
 * @CustomElement slh-textarea
 *
 * @cssprop --slh-default-font-family - Textarea font family.
 * @cssprop --slh-base-xs-font-size - Textarea font size.
 * @cssprop --slh-base-xxs-line-height - Textarea line height.
 * @cssprop --slh-base-semi-bold-font-weight - Textarea font weight.
 * @cssprop --slh-color-neutral-shade-60 - Textarea font color.
 * @cssprop --slh-color-neutral - Textarea active font color, error font color and hover font color.
 * @cssprop --slh-color-neutral-shade-00 - Textarea background and scroll background color.
 * @cssprop --slh-color-neutral-shade-40 - Textarea placeholder font color. Textarea hover border color. Disabled textarea font color. Textarea scrollbar color.
 * @cssprop --slh-color-neutral-shade-20 - Textarea border color. Textarea error state background color.
 * @cssprop --slh-color-error - Textarea error state label color.
 * @cssprop --slh-color-error-shade-80 - Textarea error state hover border color.
 * @cssprop --slh-color-neutral-shade-10 - Disabled textarea background color.
 * @cssprop --slh-color-primary-shade-60 - Textarea active state border color.
 * @cssprop --slh-color-primary-shade-20 - Textarea active state background color
 * @cssprop --slh-color-error-shade-60 - Textarea error state border color.
 * @cssprop --slh-color-error-shade-20 - Textarea error state background color.
 * @cssprop --slh-color-error-shade-40 - Textarea error state focus shadow color.
 * @cssprop --slh--base-bold-font-weight - Textarea hint font weight.
 * @cssprop --slh--base-xxs-font-size - Textarea hint font size.
 *
 * @slot default - You should provide string as slh-textarea value.
 * @slot label - You should provide slh-label component. Assigned slot nodes are parsed so that only slh-label components are shown.
 * @slot hint - Custom content below the textarea, designed to contain recommendations for user input.
 */
@customElement("slh-textarea")
export default class SlhTextarea
  extends SlhCoreTextarea(LitElement)
  implements SlhFormElement
{
  static styles = style;

  // eslint-disable-next-line class-methods-use-this
  private getHintIcon(): HTMLElement {
    return SlhFormIcons.getHintIcon();
  }
}
